module.exports = "/assets/data/833e085c74020b5fe2c4779dc9e86722-BS23.data.json";